<div class="modal-header">
  <h4 class="modal-title">
    <i class="fa fa-check-circle text-success me-2"></i>
    {{ 'customPayment.modal.title' | translate }}
  </h4>
</div>
<div class="modal-body">
  <div class="text-center mb-6">
    <div class="d-inline-flex align-items-center justify-content-center bg-light-success rounded-circle mb-4" style="width: 80px; height: 80px;">
      <i class="fa fa-clipboard-check text-success fs-2x"></i>
    </div>
    <h5 class="fw-bold">{{ 'customPayment.modal.registrationComplete' | translate }}</h5>
    <p class="text-muted">{{ eventName }}</p>
  </div>

  <div class="notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 mb-6">
    <i class="fa fa-exclamation-triangle text-warning fs-2 me-4"></i>
    <div class="d-flex flex-stack flex-grow-1">
      <div class="fw-semibold">
        <h4 class="text-gray-900 fw-bold">{{ 'customPayment.modal.paymentRequired' | translate }}</h4>
        <div class="fs-6 text-gray-700">
          {{ 'customPayment.modal.paymentRequiredDesc' | translate }}
        </div>
      </div>
    </div>
  </div>

  <div class="card bg-light mb-4">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <span class="fw-semibold text-gray-700">{{ 'customPayment.modal.amountToPay' | translate }}</span>
        <span class="fs-2 fw-bolder text-primary">{{ totalAmount | number:'1.0-2' }} {{ currency }}</span>
      </div>

      <div class="separator my-4"></div>

      <div class="mb-4">
        <label class="form-label fw-bold text-gray-800">
          <i class="fa fa-credit-card me-2"></i>
          {{ 'customPayment.modal.paymentMethod' | translate }}
        </label>
        <div class="fs-5 text-gray-700">{{ paymentMethodName }}</div>
      </div>

      <div>
        <label class="form-label fw-bold text-gray-800">
          <i class="fa fa-info-circle me-2"></i>
          {{ 'customPayment.modal.paymentInstructions' | translate }}
        </label>
        <div class="bg-white rounded p-4 fs-6 text-gray-700" style="white-space: pre-wrap;">{{ paymentInstructions }}</div>
      </div>
    </div>
  </div>

  <div class="alert alert-light-info">
    <i class="fa fa-info-circle me-2"></i>
    {{ 'customPayment.modal.statusNote' | translate }}
  </div>
</div>
<div class="modal-footer">
  <app-button
    [variant]="'primary'"
    [label]="'customPayment.modal.understood' | translate"
    [iconClass]="'fa fa-check'"
    (clicked)="close()"
  />
</div>
